module.exports = __webpack_public_path__ + "static/Guardianship-cc954ee23d59c3919aac7d3243a24adc.gif";